import { Entity, mapEntity } from '@toggle/toggle';

import { ChatDropdown } from '~/components/chat-dropdown-item/ChatDropdownItem';

export function hasEntityLoaded(items: ChatDropdown[], value: string) {
  return value ? items.some(({ rightText }) => rightText === value) : true;
}

export const mapEntityItems = (tags: Entity[]): ChatDropdown[] =>
  tags.map(item => {
    const name = item.name_short || item.name_full;
    const mappedEntity = mapEntity(item);

    return {
      leftText: mappedEntity.formattedTicker,
      rightText: name,
      tag: item.tag,
      id: item.id,
      defaultSnake: mappedEntity.default_snake,
      description: name,
      entity: mappedEntity,
    };
  });
